import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { validateInput } from "../../utilities/Validator";
import "../../css/common.css";
import { createAlert } from "../../../features/alert/alerts";
import { ALERT_TYPE_ERROR } from "../../../constants/constants";
import { useDispatch } from "react-redux";
const PasswordField = ({
  value,
  name,
  label,
  placeholder,
  required,
  validators,
  disabled,
  type,
  onChange,
  labelClass,
  spanTitle,
  inputClass,
  iconclass,
  getError,
  Error,
  onPaste,
  onDrop,
  onCut,
  onCopy,
  autoComplete,
}) => {
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch()
  useEffect(() => {}, []);
  const handleChange = (event) => {
    const { value } = event.target;
    if (validateInput(validators, value))
      setError(validateInput(validators, value));
    else if (
      !validateInput(validators, value) &&
      value !== ""
    ) {
      setSuccess(true);
      setError(false);
    } else {
      setError(false);
    }
    onChange(value);
    getError &&
      getError(
        validateInput(validators, value)
          ? validateInput(validators, value)
          : false
      );
  };
  const [passwordShown, setpasswordShown] = useState(false);
  const toggleChange = () => {
    setpasswordShown(!passwordShown);
  };
  const toggle = {
    position: "relative",
    top: "-30px",
    left: "89%",
    color: "rgba(0, 0, 0, 0.6)",
    textDecoration: "none",
    fontSize: "14px",
  };

  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: "Reject",
      })
    );
  };
  
  const preventCopyPaste = (e) => {
    e.preventDefault();
    onReject("Copy paste not allowed!");
  };

  return (
    <>
      {label && (
        <div className={labelClass}>
          <label className="password-label">
            {label} {required && <b className={"text-danger"}>*</b>}
          </label>
        </div>
      )}
      <div className={inputClass}>
        <div className="form-group">
          <input
            name={name}
            type={passwordShown ? "text" : "password"}
            placeholder={placeholder}
            onChange={handleChange}
            value={value}
            onPaste={onPaste === true ? (e) => preventCopyPaste(e) : ""}
            onDrop={onDrop === true ? (e) => preventCopyPaste(e) : ""}
            onCut={onCut === true ? (e) => preventCopyPaste(e) : ""}
            onCopy={onCopy === true ? (e) => preventCopyPaste(e) : ""}
            autoComplete={autoComplete}
            disabled={disabled}
            className={
              error
                ? "library-input form-control error"
                : success
                ? "library-input form-control success"
                : "library-input form-control"
            }
          ></input>
          
            <a
              style={toggle}
              className=""
              href="#!"
              onClick={toggleChange}
            >
              {passwordShown ?<i className={"fa fa-eye-slash"}></i> : <i className={"fa fa-eye"}></i>}
            </a>
          
          {/* {spanTitle &&
          <span className="spanMovingUp">{spanTitle}</span>
          } */}
          {/* {iconclass && <i className={iconclass}></i>} */}
          {spanTitle && <small>{spanTitle}</small>}
          {(error || (Error && Error[name])) && (
            <span className="text-danger errormsg">
              {error.message || Error[name]}
            </span>
          )}
        </div>
      </div>
    </>
  );
};

PasswordField.prototype = {
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  validators: PropTypes.array,
  type: PropTypes.string,
  onchange: PropTypes.func.isRequired,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string,
};

PasswordField.defaultProps = {
  value: "",
  label: "",
  placeholder: "",
  type: "text",
  validators: [],
  labelClass: "col-md-4",
  inputClass: "col-md-6",
};
export default PasswordField;
